<template>
  <div v-if="vendorData" class="main-container-shipmentinfo">
    <div class="inner-container">
        <div class="confirm-container-main">
            <div class="close-shipment-info-container">
                <svg class="close-shipment-info" @click="closeVendorInfo()" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                    <path d="M255.997 460.351c112.685 0 204.355-91.668 204.355-204.348S368.682 51.648 255.997 51.648c-112.68 0-204.348 91.676-204.348 204.355s91.668 204.348 204.348 204.348zm0-376.463c94.906 0 172.123 77.209 172.123 172.115 0 94.898-77.217 172.117-172.123 172.117-94.9 0-172.108-77.219-172.108-172.117-.001-94.906 77.207-172.115 172.108-172.115z" fill="#32ccfe" class="fill-000000"></path>
                    <path d="M172.077 341.508a18.35 18.35 0 0 0 12.903 5.27c4.776 0 9.54-1.84 13.151-5.512l57.865-58.973 57.878 58.973a18.372 18.372 0 0 0 13.146 5.512c4.658 0 9.316-1.746 12.902-5.27 7.264-7.125 7.369-18.793.242-26.051l-58.357-59.453 58.357-59.461c7.127-7.258 7.021-18.92-.242-26.047-7.252-7.123-18.914-7.018-26.049.24l-57.878 58.971-57.865-58.971c-7.135-7.264-18.797-7.363-26.055-.24-7.258 7.127-7.369 18.789-.236 26.047l58.351 59.461-58.351 59.453c-7.131 7.258-7.02 18.926.238 26.051z" fill="#32ccfe" class="fill-000000"></path>
                </svg>
            </div>

            <div class="confirm-header-container">
                <h1 class="package-details-header">Vendor Details</h1>
                <span class="vendor-code-badge">{{ vendorData.vendor }}</span>
            </div>

            <div class="inner-overflow-container">
                <div class="vendor-grid">
                    <!-- Vendor identity -->
                    <section class="vendor-section">
                        <div class="section-header">
                            <h2>Vendor Info</h2>
                        </div>
                        <div class="section-body">
                            <div class="confirmLabelContainer">
                                <label for="vendorName">Vendor Name</label>
                                <input id="vendorName" type="text" v-model="vendorData.vendorName" placeholder="Vendor Name">
                            </div>

                            <div class="confirmLabelContainer">
                                <label for="status">Status</label>
                                <select id="status" v-model="vendorData.status">
                                    <option :value="null">— None —</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">Inactive</option>
                                </select>
                            </div>

                            <div class="confirmLabelContainer">
                                <label for="phoneNumber">Phone Number</label>
                                <input id="phoneNumber" type="text" v-model="vendorData.phoneNumber" placeholder="Phone Number">
                            </div>

                            <div class="confirmLabelContainer">
                                <label for="email">Email</label>
                                <input id="email" type="text" v-model="vendorData.email" placeholder="Email">
                            </div>
                        </div>
                    </section>

                    <!-- Billing -->
                    <section class="vendor-section">
                        <div class="section-header">
                            <h2>Billing</h2>
                        </div>
                        <div class="section-body">
                            <div class="confirmLabelContainer">
                                <label for="billFrequency">Bill Frequency</label>
                                <select id="billFrequency" v-model="vendorData.billFrequency">
                                    <option :value="null">— None —</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="bimonthly">Bi-Monthly</option>
                                    <option value="suspended">Suspended</option>
                                </select>
                            </div>

                            <div class="confirmLabelContainer">
                                <label for="billRunDate">Bill Run Date</label>
                                <input id="billRunDate" type="date" v-model="billRunDateInput" placeholder="Bill Run Date">
                            </div>

                            <!-- invoiceSequence is maintained by backend processing; display read-only. -->
                            <div class="confirmLabelContainer">
                                <label for="invoiceSequence">Invoice Sequence</label>
                                <input id="invoiceSequence" type="text" disabled :value="invoiceSequenceDisplay" placeholder="Invoice Sequence">
                            </div>
                        </div>
                    </section>

                    <!-- Fuel surcharge (read-only, maintained by backend) -->
                    <section class="vendor-section vendor-section-full">
                        <div class="section-header">
                            <h2>Fuel Surcharge</h2>
                            <span class="readonly-tag">Read-only</span>
                        </div>
                        <div class="section-body">
                            <div v-if="fuelSurchargeList.length" class="fuel-surcharge-grid">
                                <div v-for="(surcharge, index) in fuelSurchargeList" :key="index" class="fuel-surcharge-item">
                                    <p class="fs-title">{{ surcharge.description || surcharge.fuelSurchargeCode || '—' }}</p>
                                    <p><span class="fs-label">Code</span> {{ surcharge.fuelSurchargeCode || '—' }}</p>
                                    <p><span class="fs-label">Rate</span> {{ surcharge.fuelSurchargeRate }}</p>
                                    <p><span class="fs-label">Special Rate</span> {{ surcharge.specialRate ? 'Yes' : 'No' }}</p>
                                </div>
                            </div>
                            <p v-else class="fuel-surcharge-empty">No fuel surcharge entries.</p>
                        </div>
                    </section>
                </div>
            </div>

            <loading-charts v-if="loadingData"/>
            <button class="print-button" @click="updateVendorInfo()">Update Vendor</button>
        </div>
    </div>
    <div v-if="loadingData">
        <LoadingData :headerMessage="headerMessage"/>
    </div>
  </div>
  <AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import { API } from 'aws-amplify';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue';
import LoadingData from '../../Popups/LoadingData.vue';

export default {
    props: ['vendorID', 'jwtToken'],
    components: {
        AlertUser,
        LoadingCharts,
        LoadingData,
    },
    data() {
        return {
            vendorData: null,
            loadingData: false,
            headerMessage: "",
            toggleAlertBox: false,
            alertMessage: null,
        };
    },
    computed: {
        // Bridge between the <input type="date"> (YYYY-MM-DD) and the stored value.
        // Mirrors the AccountInfo ISO-date computed bridge; handles a null billRunDate.
        billRunDateInput: {
            get() {
                const val = this.vendorData?.billRunDate;
                if (!val) return "";
                return String(val).slice(0, 10);
            },
            set(value) {
                if (!this.vendorData) return;
                if (!value) {
                    this.vendorData.billRunDate = null;
                    return;
                }
                this.vendorData.billRunDate = value + "T00:00:00Z";
            }
        },
        // invoiceSequence is read-only; display a placeholder when null/undefined.
        invoiceSequenceDisplay() {
            const val = this.vendorData?.invoiceSequence;
            return (val === null || val === undefined) ? "—" : val;
        },
        // fuelSurcharge is stored as AWSJSON (a list). Parse defensively for read-only display.
        fuelSurchargeList() {
            const raw = this.vendorData?.fuelSurcharge;
            if (!raw) return [];
            let parsed = raw;
            if (typeof raw === "string") {
                try {
                    parsed = JSON.parse(raw);
                } catch (e) {
                    return [];
                }
            }
            return Array.isArray(parsed) ? parsed : [];
        }
    },
    methods: {
        // Inline query that omits createdAt/updatedAt to avoid AWSDateTime null issues.
        async getVendorData() {
            let graphqlQuery = `query getVendor {
                getVendor(vendor: "${this.vendorID}") {
                    vendor
                    vendorName
                    status
                    phoneNumber
                    email
                    fuelSurcharge
                    billFrequency
                    billRunDate
                    invoiceSequence
                }
            }`;

            try {
                let getVendorInfo = await API.graphql({
                    query: graphqlQuery,
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });
                this.vendorData = getVendorInfo.data.getVendor;
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting vendor";
            }
        },
        // Inline mutation that only selects the PK back to avoid AWSDateTime null issues.
        async updateVendorInfo() {
            this.loadingData = true;
            try {
                await API.graphql({
                    query: `mutation MyMutation($input: UpdateVendorInput!) {
                        updateVendor(input: $input) {
                            vendor
                        }
                    }`,
                    variables: {
                        input: this.buildVendorInput(),
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });
                this.toggleAlertBox = true;
                this.alertMessage = "Vendor updated";
                await this.getVendorData();
            } catch (e) {
                console.log(e);
                this.toggleAlertBox = true;
                this.alertMessage = "Error updating vendor";
            } finally {
                this.loadingData = false;
            }
        },
        // Build the update input from editable fields.
        // fuelSurcharge/invoiceSequence are read-only here and are not written back.
        buildVendorInput() {
            return {
                vendor: this.vendorData.vendor,
                vendorName: this.vendorData.vendorName,
                status: this.vendorData.status,
                phoneNumber: this.vendorData.phoneNumber,
                email: this.vendorData.email,
                billFrequency: this.vendorData.billFrequency,
                billRunDate: this.vendorData.billRunDate,
            };
        },
        closeAlertBox(toggleAlertBox) {
            this.toggleAlertBox = toggleAlertBox;
        },
        closeVendorInfo() {
            this.$emit('closeVendorInfo', false);
        },
    },
    mounted() {
        this.getVendorData();
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
};
</script>

<style scoped>
/* Overlay popup wrapper (mirrors AccountInfo.vue) so the vendor editor renders
   as a centered modal-style card rather than inline at the bottom of the dashboard. */
.main-container-shipmentinfo {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    margin: 0;
    padding: 0;
    z-index: 10;
}

@keyframes shipment-details-animate {
    from {
        margin-top: -2%;
    }
    to {
        margin-top: 2.5%;
    }
}

.inner-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;
    flex-direction: column;
}

.confirm-container-main {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 700px;
    max-width: 90vw;
    max-height: 90vh;
    overflow-y: auto;
    overflow-x: hidden;
    animation: shipment-details-animate 1s ease;
    margin-top: 2.5%;
    background-color: #fff;
    border-radius: 25px;
    padding-bottom: 20px;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
}

.confirm-header-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0px 20px 10px 20px;
    justify-content: space-between;
}

.package-details-header {
    margin: 0;
}

.vendor-code-badge {
    background-color: #32ccfe;
    color: #fff;
    font-weight: bold;
    padding: 6px 14px;
    border-radius: 20px;
    font-size: 14px;
    letter-spacing: 0.5px;
}

/* Two-column responsive layout for the vendor sections. */
.vendor-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
}

.vendor-section {
    background-color: #f7fbfd;
    border: 1px solid #e3eef3;
    border-radius: 15px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.vendor-section-full {
    grid-column: 1 / -1;
}

.section-header {
    background-color: #eaf7fd;
    border-bottom: 1px solid #d5ecf5;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.section-header h2 {
    margin: 0;
    font-size: 16px;
    color: #1c6f8c;
}

.readonly-tag {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #6c8894;
    background-color: #fff;
    border: 1px solid #d5ecf5;
    border-radius: 12px;
    padding: 2px 8px;
}

.section-body {
    padding: 5px 15px 15px 15px;
}

.close-shipment-info-container {
    display: flex;
    justify-content: flex-end;
    padding: 15px 15px 0 0;
}

.close-shipment-info {
    width: 30px;
    height: 30px;
    cursor: pointer;
}

.inner-overflow-container {
    padding: 0 20px;
}

input, select {
    padding: 10px;
    font-size: 15px;
    border: 1px solid rgba(0, 0, 0, .336);
    border-radius: 15px;
    outline: none;
    margin-top: 5px;
}

.confirmLabelContainer {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-top: 10px;
}

.confirmLabelContainer label {
    font-weight: bold;
}

.fuel-surcharge-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 10px;
    margin-top: 10px;
}

.fuel-surcharge-item {
    background-color: #fff;
    border: 1px solid #e2e2e2;
    border-radius: 12px;
    padding: 10px 12px;
}

.fuel-surcharge-item p {
    margin: 3px 0;
    font-size: 14px;
}

.fs-title {
    font-weight: bold;
    color: #1c6f8c;
    margin-bottom: 6px !important;
}

.fs-label {
    display: inline-block;
    min-width: 90px;
    color: #6c8894;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
}

.fuel-surcharge-empty {
    color: #777;
    font-style: italic;
    margin-top: 10px;
}

.print-button {
    cursor: pointer;
    border: none;
    background-color: #32ccfe;
    color: #fff;
    padding: 10px 20px;
    border-radius: 15px;
    margin-top: 15px;
    transition: background-color 0.3s;
}

.print-button:hover {
    background-color: #2baeda;
}

@media only screen and (max-width: 820px) {
    .confirm-container-main {
        width: 92vw;
    }
}

@media only screen and (max-width: 600px) {
    .vendor-grid {
        grid-template-columns: 1fr;
    }
}

@media only screen and (max-width: 530px) {
    .confirm-container-main {
        width: 96vw;
    }
}
</style>
